export enum DashboardListBarVariant {
  Actual = 'actual',
  Loss = 'loss',
  Gain = 'gain',
}

export enum DashboardListBarAnchor {
  Left = 'left',
  Right = 'right',
}
